export const UITextInput = ({
  id,
  type = "text",
  placeholder,
  value,
  onChange,
  disabled = false,
  className = "",
  autoComplete,
}) => (
  <input
    id={id}
    type={type}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    disabled={disabled}
    autoComplete={autoComplete}
    className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 disabled:bg-gray-200 disabled:text-gray-500 ${className}`}
  />
);
